import getStore from '../store/store';
import isFileProviderEnabled from '../utils/isFileProviderEnabled';
import { ADDABLE_FILE_PROVIDERS_LIST, FileProviderType } from '../utils/constants';
import { getAddableFileProviderInfo } from 'owa-add-fileprovider';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';

function getAddableFileProviders(providers?: FileProviderType[]): FileProviderType[] {
    const addableProviders = ADDABLE_FILE_PROVIDERS_LIST;

    if (providers) {
        addableProviders.filter(provider => providers.indexOf(provider) > -1);
    }

    addableProviders.forEach(p => getAddableFileProviderInfo(p as AttachmentDataProviderType));
    return addableProviders.filter(
        provider =>
            isFileProviderEnabled(provider) && !getStore().providers.has(provider.toString())
    );
}

export { getAddableFileProviders };
